import { Injectable } from "@angular/core";
import { Actions, createEffect, ofType } from "@ngrx/effects";
import { catchError, map, merge, mergeMap, of, pipe, switchMap, tap } from "rxjs";
import * as DeviceLocationActions from "./device-locations-actions";
import { AppNotificationService } from "src/app/shared/services/notification.service";
import { translate } from '@jsverse/transloco';
import { DeviceService } from "src/app/devices/services/device.service";
import { IDeviceLocation } from "src/app/devices/models/device-location";

@Injectable()
export class DeviceLocationsEffects {

    ///////////////////////////
    // GET DEVICE LOCATIONS //
    /////////////////////////

    // Get Device Location
    getDeviceLocationsByCompany$ = createEffect(() =>
        this.actions$.pipe(
            ofType(DeviceLocationActions.getDeviceLocationsByCompany), 
            mergeMap((action) => {
            return this.deviceService.getDeviceLocationsByCompany({pageNumber: 0, pageSize: 99999, companyId: action.companyId}).pipe(
                map((response) => 
                    DeviceLocationActions.getDeviceLocationsByCompanySuccess({ deviceLocations: response.data })
                ), 
                catchError((error) =>
                    of(DeviceLocationActions.getDeviceLocationsByCompanyFailure({ error: error.message }))
                )
            );
        })
        )
    );




    /////////////////////////////
    // CREATE DEVICE LOCATION //
    ///////////////////////////

    // Create Device Location
    createDeviceLocation$ = createEffect(() =>
      this.actions$.pipe(
          ofType(DeviceLocationActions.createDeviceLocation),
          mergeMap((action) => 
              this.deviceService.createDeviceLocation(action.deviceLocation).pipe(
                  map((deviceLocation: IDeviceLocation) => DeviceLocationActions.createDeviceLocationSuccess({ deviceLocation })),
                  catchError((error) => of(DeviceLocationActions.createDeviceLocationFailure({ error: error.message })))
              )
          )
      )
    );

    // Device Location created successfully
    createDeviceLocationSuccess$ = createEffect(() => 
        this.actions$.pipe(
            ofType(DeviceLocationActions.createDeviceLocationSuccess),
            tap(() => {
                this.appnotificationService.notification$.next({ message:translate('deviceLocations.createSuccess'), style: 'success' });
            })
        ), { dispatch: false }
    );

    // Device Location not created successfully
    createDeviceLocationFailure$ = createEffect(() => 
      this.actions$.pipe(
          ofType(DeviceLocationActions.createDeviceLocationFailure)
      ), { dispatch: false }
    );




    /////////////////////////////
    // UPDATE DEVICE LOCATION //
    ///////////////////////////

    // Update Device Location
    updateDeviceLocation$ = createEffect(() =>
        this.actions$.pipe(
            ofType(DeviceLocationActions.updateDeviceLocation),
            mergeMap((action) => 
                this.deviceService.updateDeviceLocation(action.deviceLocation).pipe(
                    map((deviceLocation: IDeviceLocation) => DeviceLocationActions.updateDeviceLocationSuccess({ deviceLocation })),
                    catchError((error) => of(DeviceLocationActions.updateDeviceLocationFailure({ error: error.message })))
                )
            )
        )
    );
  
    // Update Device Location successful
    updateDeviceLocationsuccess$ = createEffect(() => 
        this.actions$.pipe(
            ofType(DeviceLocationActions.updateDeviceLocationSuccess),
            tap(() => {
                this.appnotificationService.notification$.next({ message:translate('deviceLocations.updateSuccess'), style: 'success' });
            })
        ), { dispatch: false }
    );
  
    // Device Location not updated successfully
    updateDeviceLocationFailure$ = createEffect(() => 
        this.actions$.pipe(
            ofType(DeviceLocationActions.updateDeviceLocationFailure),
            tap(() => {
                this.appnotificationService.notification$.next({ message:translate('deviceLocations.updateFailed'), style: 'error' });
            })
        ), { dispatch: false }
    );




    /////////////////////////////
    // DELETE DEVICE LOCATION //
    ///////////////////////////

    // Delete Device Location
    deleteDeviceLocation$ = createEffect(() =>
        this.actions$.pipe(
            ofType(DeviceLocationActions.deleteDeviceLocation), 
            mergeMap((action) => {
                return this.deviceService.deleteDeviceLocation(action.id).pipe(
                    map(() => DeviceLocationActions.deleteDeviceLocationSuccess({id: action.id})), 
                    catchError((error) => of(DeviceLocationActions.deleteDeviceLocationFailure({ error: error.message })))
            )}
        ))
    );

    // Device Location deleted successfully
    deleteDeviceLocationsuccess$ = createEffect(() => 
      this.actions$.pipe(
          ofType(DeviceLocationActions.deleteDeviceLocationSuccess),
          tap(() => {
              this.appnotificationService.notification$.next({ message:translate('deviceLocations.deleteSuccess'), style: 'success' });
          })
      ), { dispatch: false }
    );

    // Device Location not deleted successfully
    deleteDeviceLocationFailure$ = createEffect(() =>
      this.actions$.pipe(
        ofType(DeviceLocationActions.deleteDeviceLocationFailure)
      ), { dispatch: false }
    );




    constructor(
        private actions$: Actions, 
        private deviceService: DeviceService,
        private appnotificationService: AppNotificationService) {}
}